// extracted by mini-css-extract-plugin
module.exports = {"serialNumber":"transfer-sale-stock_serialNumber__1wpQY","form":"transfer-sale-stock_form__1QNSD"};